export enum FilterOptionEnum {
  ShowAllWidgets = 1,
  WidgetsUsed,
  TemplateName
}
